import { UNIT_SUGGESTIONS } from '../data/constants'

export default function UnitSelect({ id, value, onChange, disabled = false, className = 'input' }) {
  const current = String(value || '개').trim() || '개'
  const options = UNIT_SUGGESTIONS.includes(current) ? UNIT_SUGGESTIONS : [current, ...UNIT_SUGGESTIONS]

  return (
    <select
      id={id}
      className={className}
      value={current}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
    >
      {options.map((unit) => (
        <option key={unit} value={unit}>
          {unit}
        </option>
      ))}
    </select>
  )
}
